angular.module("smartorg.r6.navs.reportOptions").directive("compareTo1", [function () {
        return {
            restrict: "E",
            template: require('../../template/compare-to.html'),
            transclude: true,
            scope: {},
            link: function (scope) {
                // =====================================================
                // Here goes to real stuff
                // =====================================================
                $('[data-toggle="tooltip"]').tooltip();
                /**
                 * Clean up the compare area.
                 */
                scope.clearCompareArea = function () {
                    angular.element("#compareArea").empty();
                    angular.element("#compareArea").text("Drag a node from Navigation panel and drop it here");
                };
                /**
                 * Set compare node info by given information.
                 *
                 * @param node {any} A tree node object. The only needed
                 *     properties are _id and name.
                 */
                scope.setCompareNodeInfo = function (node) {
                    if (node) {
                        var c = document.createElement("div");
                        c.id = "compare." + node['_id'];
                        c.innerText = node['name'];
                        c.textContent = node['name'];
                        c.style.color = 'black';
                        c.style.fontStyle = 'normal';
                        angular.element("#compareArea").empty();
                        angular.element("#compareArea").append(c);
                    }
                };
                // Listen to report option events.
                scope.$on("report:compare.set", function (event, args) {
                    scope.setCompareNodeInfo(args['node']);
                });
                scope.$on("report:compare.clear", function () {
                    scope.clearCompareArea();
                });
            }
        };
    }]);
//# sourceMappingURL=compare-to-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/plumbing/compare-to-directive.js